<autocomplete-option>
  <figure>
    <partner-avatar
      [partner]="partner"
      [width]="100"
      [height]="40"
      [alt]="partner.name"
    ></partner-avatar>
  </figure>

  <div [innerHTML]="partner.name | highlight: highlight" class="main"></div>
</autocomplete-option>
